// extracted by mini-css-extract-plugin
export var interviews = "InterviewsContainer-module--interviews--2Uu6L";